import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import { EDC_PATHS, requestViewPath } from "./edcPaths";

const LEGACY_TAB_TARGETS = {
  area: requestViewPath("area"),
  engineering: requestViewPath("engineering"),
  rejected: requestViewPath("area", "RejectedRequests"),
};

/** Old /SLN/DistributionCompany/ReviewQueue?tab=… links. */
export const LegacyReviewQueueRedirect = () => {
  const [searchParams] = useSearchParams();
  const target = LEGACY_TAB_TARGETS[searchParams.get("tab")] || EDC_PATHS.root;
  return <Navigate to={target} replace />;
};

/** Old /SLN/DistributionCompany/Team link. */
export const LegacyTeamRedirect = () => <Navigate to={EDC_PATHS.users} replace />;
